// extracted by mini-css-extract-plugin
export var auto = "_4f-1";
export var spinner = "_4f-0";